import {
    SetAlarmPriorityAction, SetAudioEnableAction, SetClearAfterSelectionAction, SetFormatTimeAction,
    SetLanguageAction, SetLoadLastViewAction, SetLocalSettingsAction,
    SetNotificationPriorityAction,
    SetResponsivePaneAction, SetStoredSettingsAction, SetSynchronousPlaybackAction,
    TriggerSettingsViewAction,
    SetTimeZoneAction
} from "./types";

export const setResponsivePane = (flag: boolean) : SetResponsivePaneAction => ({type: 'setResponsivePane', flag});

export const triggerSettingsView = (payload: boolean) : TriggerSettingsViewAction => ({type: 'triggerSettingsView', payload});

export const setLanguage = (language: string) : SetLanguageAction => ({type: 'setLanguage', language});

export const setAlarmPriority = (priority: string) : SetAlarmPriorityAction => ({type: 'setAlarmPriority', priority});

export const setNotificationPriority = (priority: string) : SetNotificationPriorityAction => ({type: 'setNotificationPriority', priority});

export const setAudioEnable = (audioEnable: boolean) : SetAudioEnableAction => ({type: 'setAudioEnable', audioEnable});

export const setLocalSettings = (flag: boolean) : SetLocalSettingsAction => ({type: 'setLocalSettings', flag});

export const setClearTextAfterSelection = (flag: boolean) : SetClearAfterSelectionAction => ({type: 'setClearTextAfterSelection', flag});

export const setLoadLastView = (flag: boolean) : SetLoadLastViewAction => ({type: 'setLoadLastView', flag});

export const setSynchronousPlayback = (flag: boolean) : SetSynchronousPlaybackAction => ({type: 'setSynchronousPlayback', flag});

export const setFormatTime = (flag: boolean) : SetFormatTimeAction => ({type: 'setFormatTime', flag});

export const setTimeZone = (zone: string) : SetTimeZoneAction => ({type: 'setTimeZone', zone});

export const setStoredSettings = ({...settings} : any) : SetStoredSettingsAction => ({type: 'setStoredSettings', ...settings});